class FormatByIndex {
  private data: { [key in string]: string } = {};

  public get(key: string): string {
    return this.data[key] || key;
  }

  public set(key: string, value: string) {
    if (this.data[key] === value) {
      return;
    }
    if (!!this.data[key]) {
      this.data[key] = value;
      return;
    }
    this.data[key] = value;
  }
}

export default FormatByIndex;
